export default "__VITE_ASSET__5d3b245f__"